import type { ReactNode } from 'react';
import type { ProposalField } from './ProposalEditor';
import { inputClass } from './ModerationUi';

export function VerificationCheckbox({
  field,
  label,
  checked,
  disabled = false,
  onChange,
}: {
  field: ProposalField;
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (field: ProposalField, checked: boolean) => void;
}): JSX.Element {
  return (
    <label className="flex items-center gap-2 text-sm">
      <input
        type="checkbox"
        aria-label={`Проверено: ${label}`}
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(field, event.target.checked)}
      />
      <span>Проверено</span>
    </label>
  );
}

export function ReviewedTextInput({
  field,
  label,
  value,
  help,
  requireVerification,
  verified,
  error,
  required = true,
  disabled = false,
  secondaryControl,
  onValueChange,
  onVerificationChange,
}: {
  field: Extract<ProposalField, 'k_name' | 'k_squad' | 'v_name' | 'v_squad'>;
  label: string;
  value: string;
  help: string;
  requireVerification: boolean;
  verified: boolean;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  secondaryControl?: ReactNode;
  onValueChange: (value: string) => void;
  onVerificationChange: (field: ProposalField, checked: boolean) => void;
}): JSX.Element {
  return (
    <div className="space-y-2">
      <label className="block space-y-1">
        <span className="text-sm">{label}</span>
        <input
          aria-label={label}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? `${field}-error` : undefined}
          className={`${inputClass} ${error ? 'border-destructive bg-destructive/5' : ''} disabled:cursor-not-allowed disabled:opacity-60`}
          value={value}
          disabled={disabled}
          onChange={(event) => onValueChange(event.target.value)}
          required={required}
        />
        {requireVerification ? (
          <span className="block text-xs text-muted-foreground">{help}</span>
        ) : null}
      </label>
      {secondaryControl}
      {error ? (
        <p id={`${field}-error`} role="alert" className="text-xs text-destructive">
          {error}
        </p>
      ) : null}
      {requireVerification ? (
        <VerificationCheckbox
          field={field}
          label={label}
          checked={error ? false : verified}
          disabled={Boolean(error)}
          onChange={onVerificationChange}
        />
      ) : null}
    </div>
  );
}
